import axiosInstance from "../config/axiosInstance"

export const deleteInvestor =async   (id) => {
    const response = await axiosInstance.delete(`/api/admin/delete/investor/${id}`)
    return response;
}